<ng-container>
  <div class="md:p-4 overflow-y-scroll" [ngSwitch]="currentStep">
    <div class="business-category-content business-category-web" *ngSwitchCase="CATEGORY_STEPS.EDIT_ADD_CATEGORY">
      <div class="business-title">
        {{'moniepoint.business_Type' | translate }}
      </div>
      <div class="business-sub-title">
        {{'moniepoint.category_business' | translate }}
      </div>

      <div class="flex items-center p-4 mt-4 gap-4 bg-[#F2F7FE] rounded-md">
        <img src="assets/images/svgs/info-icon.svg" class="w-[16px] h-[16px] cursor-pointer" alt="info-icon" />

        <p class="text-[#1A1A1A] font-medium text-sm">
          Please ensure you select the right category for this business. Any incorrect or negligent classification will
          result
          in
          penalties.</p>
      </div>

      <form nz-form [formGroup]="form" autocomplete="off" class="login-form m-t-20 custom-moniepoint-select">
        <div class="m-t-24">
          <nz-form-item>
            <nz-form-control>
              <nz-select class="w-100p" [nzSuffixIcon]="customDropDown" formControlName="businessId"
                [nzLoading]="loadingCategories" nzPlaceHolder="{{'moniepoint.select_business'|translate}}">
                <nz-option *ngFor="let item of categories" [nzLabel]="item.label" [nzValue]="item.label">
                  {{item.label}}
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div class="m-t-24">
          <nz-form-item>
            <nz-form-control>
              <nz-select class="w-100p" [nzSuffixIcon]="customDropDown" [nzLoading]="loadingSubCategories"
                nzPlaceHolder="{{'moniepoint.select_sub_category'|translate}}" formControlName="businessTypeId">
                <nz-option *ngFor="let item of subCategories" [nzLabel]="item.label" [nzValue]="item.label">
                  {{item.label}}
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </form>

      <app-custom-error-display [errorMessage]="errorMessage"></app-custom-error-display>

      <div class="mt-10 md:mt-24 flex md:justify-end justify-center gap-4">
        <app-custom-button class="md:w-auto w-full" state="outline" text="Back"
          (click)="goToListCategories()"></app-custom-button>

          <app-custom-button class="md:w-auto w-full" [isBlock]="true" text="Next" (click)="handleNext()"
            [isDisabled]="!form.valid">
          </app-custom-button>
      </div>
    </div>

    <div *ngSwitchCase="CATEGORY_STEPS.LIST_CATEGORIES" class="business-category-content">
      <h3 class="business-title">Business Type</h3>
      <p class="business-sub-title">Category your business falls under</p>

      <h4 class="text-sm font-medium leading-4 mb-3 mt-8">
        Business Information
      </h4>

      <div class="rounded-xl border border-[#e5e5e5] bg-[#f8f8f8] ">
        <div class="rounded-xl bg-white p-4">
          <div class="single-category flex items-center justify-between"
            *ngFor="let categoryDetail of categoriesFormList; let idx = index">
            <div class="flex flex-col">
              <h5 class="text-base font-semibold leading-6 break-words">
                {{categoryDetail.businessCategoryName}}
              </h5>
              <p class="text-[#808080] font-medium text-[15px] break-all">
                {{categoryDetail.name}}
              </p>
            </div>

            <div class="flex gap-3 flex-none">
              <img src="assets/images/svgs/editIcon.svg" class="w-[24px] h-[24px] cursor-pointer"
                (click)="handleEditCategory(idx)" alt="Edit Business Type" />

              <img src="assets/images/svgs/trash-red.svg" class="w-[24px] h-[24px] cursor-pointer"
                (click)="handleDeleteCategory(idx)" alt="Delete Business Type" *ngIf="categoriesFormList.length > 1" />
            </div>
          </div>

          <div class="mt-4 flex items-center justify-center">
            <ng-container *ngTemplateOutlet="addIcon"></ng-container>

            <span class="text-[#0361F0] text-sm font-medium leading-[17.36px] text-center cursor-pointer"
              (click)="handleCreateCategory()">Add New Category</span>
          </div>
        </div>
      </div>

      <h4 class="text-sm font-medium leading-4 mb-3 mt-8">
        Storefront Photo
      </h4>

      <div class="rounded-xl border border-[#e5e5e5] p-4">
        <ng-container *ngIf="!storeFrontImgRef">
          <h5 class="text-sm text-black font-semibold">Upload Storefront Photo</h5>
          <p class="text-[#333333] text-xs">Please share a clear photo of your shopfront including the signpost.</p>
        </ng-container>

        <ng-container>
          <ng-container *ngIf="!loadingImage; else loading">
            <img [src]="storeFrontImg" alt="Storefront Image" width="100%" class="w-full my-2 inline-block"
              *ngIf="storeFrontImg" />
          </ng-container>
        </ng-container>

        <div class="mt-4" *ngIf="!loadingImage">
          <app-custom-image-uploader #imgUploader (getFile)="handleGetFile($event)" [useReferenceResponse]="true"
            [convertToBase64]="false" [uploadType]="'TYPE_1'" [hideTitle]="true" title="Upload New Image"
            [useDashboardServiceUpload]="true" [allowedFormats]="['.jpeg', '.png', '.jpg']" *ngIf="storeFrontImgRef"
            [maxFileSize]="maxStoreFrontFileSize">
          </app-custom-image-uploader>
          <ng-container *ngIf="!storeFrontImgRef">
            <app-custom-image-uploader #imgUploader (getFile)="handleGetFile($event)" [useReferenceResponse]="true"
              [convertToBase64]="false" [useDashboardServiceUpload]="true" [uploadType]="'TYPE_1'"
              [allowedFormats]="['.jpeg', '.png', '.jpg']" [maxFileSize]="maxStoreFrontFileSize">
            </app-custom-image-uploader>
            <div>
              <img *ngIf="canShowStoreFrontSample" src="assets/images/storefront-sample.png" alt="Sample Storefront image"
                width="100%" class="w-full my-2 inline-block" />

              <app-custom-button type="link" [text]="canShowStoreFrontSample ? 'Close sample ' : 'Show sample '"
                [suffixIcon]="caretIcon" [isBlock]="true" (click)="toggleSample()">
              </app-custom-button>
              </div>
          </ng-container>
        </div>


      </div>

      <div class="mt-8">
        <app-custom-button [isBlock]="true" text="Save Changes" (click)="handleSubmit()"
          [isSubmitting]="isSavingChanges"
          [isDisabled]="isSubmitDisabled">
        </app-custom-button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #customDropDown>
  <svg fill="none" height="8" viewBox="0 0 14 8" width="14" xmlns="http://www.w3.org/2000/svg">
    <path clip-rule="evenodd"
      d="M13.1363 0.263604C13.4878 0.615076 13.4878 1.18492 13.1363 1.5364L7.7363 6.9364C7.38483 7.28787 6.81498 7.28787 6.46351 6.9364L1.06351 1.5364C0.712035 1.18492 0.712035 0.615075 1.06351 0.263603C1.41498 -0.0878685 1.98483 -0.0878685 2.3363 0.263603L7.0999 5.02721L11.8635 0.263604C12.215 -0.087868 12.7848 -0.087868 13.1363 0.263604Z"
      fill="black" fill-rule="evenodd" />
  </svg>
</ng-template>

<ng-template #addIcon>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.5 5C13.5 4.44772 13.0523 4 12.5 4C11.9477 4 11.5 4.44772 11.5 5V11H5.5C4.94771 11 4.5 11.4477 4.5 12C4.5 12.5523 4.94771 13 5.5 13H11.5V19C11.5 19.5523 11.9477 20 12.5 20C13.0523 20 13.5 19.5523 13.5 19V13H19.5C20.0523 13 20.5 12.5523 20.5 12C20.5 11.4477 20.0523 11 19.5 11H13.5V5Z"
      fill="#0361F0" />
  </svg>
</ng-template>

<ng-template #caretIcon>
  <ng-container *ngIf="canShowStoreFrontSample else caretDown">
    <ng-container *ngTemplateOutlet="caretUp"></ng-container>
  </ng-container>
</ng-template>

<ng-template #caretDown>
  <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg"
    class="inline-block ml-2">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M6.03033 5.78033C5.73744 6.07322 5.26256 6.07322 4.96967 5.78033L0.46967 1.28033C0.176777 0.987437 0.176777 0.512563 0.46967 0.21967C0.762563 -0.0732231 1.23744 -0.0732231 1.53033 0.21967L5.5 4.18934L9.46967 0.21967C9.76256 -0.0732231 10.2374 -0.0732231 10.5303 0.21967C10.8232 0.512563 10.8232 0.987437 10.5303 1.28033L6.03033 5.78033Z"
      fill="#0361F0" />
  </svg>
</ng-template>

<ng-template #caretUp>
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"
    class="inline-block ml-2">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M7.46967 5.79779C7.76256 5.5049 8.23744 5.5049 8.53033 5.79779L13.0303 10.2978C13.3232 10.5907 13.3232 11.0656 13.0303 11.3585C12.7374 11.6513 12.2626 11.6513 11.9697 11.3585L8 7.38879L4.03033 11.3585C3.73744 11.6513 3.26256 11.6513 2.96967 11.3585C2.67678 11.0656 2.67678 10.5907 2.96967 10.2978L7.46967 5.79779Z"
      fill="#0361F0" />
  </svg>
</ng-template>

<ng-template #plusIcon>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5V11H5C4.44771 11 4 11.4477 4 12C4 12.5523 4.44771 13 5 13H11V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H13V5Z"
      fill="#0361F0" />
  </svg>
</ng-template>

<ng-template #loading>
  <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 4 }"></nz-skeleton>
</ng-template>

<ng-container *ngIf="showUploadImageErrorModal">
	<ng-container *ngIf="!isMobileView else mobileAlert">
		<app-web-kamona-message-widget
			[modalType]="ModalTypeEnum.CUSTOM"
		>
			<ng-container *ngTemplateOutlet="invalidImageContent"></ng-container>
		</app-web-kamona-message-widget>
	</ng-container>
</ng-container>

<ng-template #mobileAlert>
	<app-mobile-kamona-message-widget
		[modalType]="ModalTypeEnum.CUSTOM"
		(emitCancel)="handleCloseAlertModal()"
  >
    <ng-container *ngTemplateOutlet="invalidImageContent">
    </ng-container>
  </app-mobile-kamona-message-widget>
</ng-template>

<ng-template #invalidImageContent>
	<div class="flex flex-col items-center">
		<div class="flex justify-center">
			<img 
				src="assets/images/svgs/error-lg.svg" 
				class="w-[45px] h-[45px]" 
			/>
		</div>

		<h3 class="leading-[29.76px] text-black text-[24px] font-bold mt-4 mb-2 text-center">
			{{uploadImageError}}
		</h3>
		<p class="text-[14px] text-[#1a1a1a] leading-[19.6px] mb-6 text-center">
			Make sure your photo clearly shows the front of your shop with the sign or logo.
		</p>

		<div class="flex items-center gap-2 justify-center">
			<svg width="166" height="2" viewBox="0 0 166 2" fill="none" 		xmlns="http://www.w3.org/2000/svg">
				<path d="M0 1H166" stroke="#CED6E3"/>
			</svg>
				
			<h4 class="text-sm font-bold text-[#1a1a1a] leading-[19.6px]">
				Sample
			</h4>

			<svg width="166" height="2" viewBox="0 0 166 2" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M0 1H166" stroke="#CED6E3"/>
			</svg>
		</div>

		<img 
			src="assets/images/storefront-sample-lg.png" 
			alt="Sample Storefront image" 
			width="100%" 
			class="w-full mt-2 mb-6 inline-block max-w-[400px] min-h-[238px] object-contain rounded-lg"
		/>

		<app-custom-button state="lightsecondary" text="Try again" class="min-w-[335px] max-w-[350px]" (click)="handleCloseAlertModal()"></app-custom-button>
	</div>
</ng-template>